/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
///<reference path="../../components/common/ratings.service.ts"/>

module Meevo.Plugins.Employee {
    'use strict';

    import EmployeeRequestType = Meevo.Model.EmployeeRequestType;
    import IPromise = angular.IPromise;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IContextMessages {
        sectionMain: string;
        activateUser: string;
        activateUserWithPromo: string;
        clientLinkConfirmation: string;
        terminateWithPromo: string;
        terminateConfirmation: string;
        deleteWithPromoConfirm: string;
        deleteConfirm: string;
        deleteFutureWorkTimeConfirm: string;
        deleteFutureBlockTimeConfirm: string;
        applyTemplateConfirm: string;
        cannotTemplateNew: string;
    }

    export interface IRatingLabels {
        stars: string | number;
        reviews: string | number;
    }

    export class EmployeeContext extends Components.BaseClasses.DataMaintenanceContextBase {
        employeeDetail: Model.DataDetail;
        private _filterService: angular.IFilterService;
        protected rootScope: ng.IRootScopeService;
        protected busyService: Components.Busy.IBusyService;
        public userNamePattern = /^[a-zA-Z0-9]*$/;
        employeePhoto: any = undefined;
        notificationSetting: Model.NotificationSetting;
        private rating: any;
        private ratingLabels: IRatingLabels = { stars: null, reviews: null }
        protected imageGalleryService: any;
        protected ratingsService: Meevo.Components.Common.IRatingsService;
        private pagerEmpServiceFilterCanPerforme: any;
        protected timeout: ng.ITimeoutService;
        private serviceCanPerformFlag: boolean = false;
        private CanPerformFlagSetToShowAll: boolean = false;
        public locationGroupRoleTemplate = 'locationgroupuserrole';
        public allowSpecificEmployee: boolean;
        public meevoMessengerSecurityKey: string;
        protected mainTabAccessHide: boolean = false;
        protected get contextMessages(): IContextMessages {
            return {
                sectionMain: 'SECTION_EMPLOYEE_MAIN',
                activateUser: 'MESSAGE_ACTIVATE_USER_CONFIRMATION',
                activateUserWithPromo: 'MESSAGE_INACTIVATE_EMPLOYEE_WITH_PROMO_CONFIRMATION',
                clientLinkConfirmation: 'MESSAGE_EMPLOYEE_CLIENT_LINK_CONFIRMATION',
                terminateWithPromo: 'MESSAGE_TERMINATE_EMPLOYEE_WITH_PROMO_CONFIRMATION',
                terminateConfirmation: 'MESSAGE_TERMINATE_EMPLOYEE_CONFIRMATION',
                deleteWithPromoConfirm: 'MESSAGE_DELETE_EMPLOYEE_WITH_PROMO_CONFIRMATION',
                deleteConfirm: 'MESSAGE_DELETE_EMPLOYEE_CONFIRMATION',
                deleteFutureWorkTimeConfirm: 'MESSAGE_DELETE_FUTURE_WORKTIME_CONFIRM',
                deleteFutureBlockTimeConfirm: 'MESSAGE_DELETE_FUTURE_BLOCKTIME_CONFIRM',
                applyTemplateConfirm: 'MESSAGE_CONFIRM_APPLY_TEMPLATE_ON_EMPLOYEE',
                cannotTemplateNew: 'MESSAGE_EMPLOYEE_CANNOT_TEMPLATE_NEW',
            }
        }

        protected get pluginFolder(): string {
            return 'employee';
        }

        get customTabId(): number {
            return 99;
        }
        get customSecurityEntity(): number {
            return SecurityEntityTypeEnum.UdfEmployeee;
        }

        get customTabSecurityKey(): string {
            return this.securityKeys.DATA_EMPLOYEE_TAB_CUSTOMUDFTABS;
        }

        constructor(appSettings: Components.Common.IAppSettings,
            dataService: Components.BaseClasses.IDataService,
            modalService: Components.Modal.IModalService,
            identityService: Components.Common.IIdentityService,
            loggingService: Components.Logging.ILoggingService,
            securityChecker: Components.Common.ISecurityService,
            trackingService: Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService,
            busyService: Components.Busy.IBusyService,
            customDataContextConfig: Model.ICustomDataContextConfig,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            ratingsService: Meevo.Components.Common.IRatingsService,
            $timeout: ng.ITimeoutService,
            _employeeDetail?: Model.DataDetail,
            public $translate?: angular.translate.ITranslateService,
            canLocationAddUser?: number) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService,
                customDataContextConfig, false);

            this.canLocationAddUser = canLocationAddUser;

            this.rootScope = rootScope;
            this.busyService = busyService;
            this.imageGalleryService = imageGalleryService;
            this.ratingsService = ratingsService;
            this.employeeDetail = _employeeDetail;
            this.timeout = $timeout;
            this.initializeContext();
            this.initializeSections();
            this.allowSpecificEmployee = this.appSettings.APP_BUSINFOSETTINGS.onlineBookingSettings.allowSpecificEmployee;
            if (this.identityService.current().fullAccess) {
                this.locationGroupRoleTemplate = 'securityrole';
            }
        }

        get actingLocationId(): number {
            return Model.Guard.isSomething(this.asLocationId)
                ? this.asLocationId
                : this.identityService.current().centralOfficeId;
        }

        initializeContext(): void {
            // initialize end points
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employee;
            // initialize templatepaths
            this.sectionTemplatePath = 'app/plugins/employee/sectionViews/';

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            //this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN, true, true, false, false, false);
        }

        reinitializeSetcions(): void {
            this.sections = [];
            this.initializeSections();
        }


        initializeSections(): void {
            this.initializeContext();
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    'SECTION_EMPLOYEE_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeMain,
                    this.appSettings,
                    this.asLocationId,
                    this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.modalService,
                    this.employeeDetail,
                    this));
                this.initializeMeevoMessengerSecurity();
            } else {
                this.mainTabAccessHide = true;
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LocationSection(1,
                    'SECTION_EMPLOYEE_LOCATIONS',
                    'locations.html',
                    false,
                    false,
                    '',
                    'security',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeSecurity,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.modalService,
                    this));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServicesSection(2,
                    'SECTION_EMPLOYEE_SERVICES',
                    'services.html',
                    false,
                    false,
                    '',
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeServices,
                    this.appSettings,
                    this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityChecker));


            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SHARED + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new SharedSection(3,
                    'SECTION_EMPLOYEE_SHARED',
                    'shared.html',
                    false,
                    false,
                    '',
                    'shared',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeShared,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_SHARED + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new CompensationSection(4,
                    'SECTION_EMPLOYEE_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    '',
                    'compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeCompensation,
                    this.modalService,
                    this.appSettings,
                    this.securityKeys.DATA_EMPLOYEE_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new DeductionSection(5,
                    'SECTION_EMPLOYEE_DEDUCTION',
                    'deduction.html',
                    false,
                    false,
                    '',
                    'deduction',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeeDeductions,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServiceCommissionsSection(6,
                    "SECTION_EMPLOYEE_SERVICE_COMMISSIONS_OVERRIDE",
                    "servicesCommissions.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeCommissionOverrides,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new OnlineBookingSection(7,
                    "SECTION_EMPLOYEE_ONLINEBOOKING",
                    "OnlineBooking.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "OnlineBooking",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeOnlineBooking,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new BookingRestrictionsSection(8,
                    "SECTION_EMPLOYEE_BOOKING_RESTRICTIONS",
                    "bookingRestrictions.template.html",
                    false,
                    false,
                    this.baseEndpoint,
                    'BookingRestrictions',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeBookingRestrictions,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LicensesInsuranceSection(9,
                    'SECTION_EMPLOYEE_LICENSE_INSURANCE',
                    'licensesInsurance.html',
                    false,
                    true,
                    '',
                    'licensesinsurances',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeLicenseInsurance,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ImageGallerySection(10,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeImageGallery,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new NotesSection(11,
                    'SECTION_CLIENT_NOTES',
                    'notes.html',
                    false,
                    true,
                    '',
                    'notes',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeNotes,
                    this.modalService,
                    this.securityKeys.DATA_EMPLOYEE_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }
        }


        //student teacher extends the employee context and calling super.selectSection was replacing student/teacher keys with employee keys
        //this method allows byPassing the key replacement and calls DataMaintenanceContextBase.selectSection as some required code is excuted there.
        byPassEmployeeSelectSection(item): void {
            super.selectSection(item);
        }

        selectSection(item): void {

            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_LOCATIONS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_SHARED);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_PAYROLL);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_DEDUCTION);
                    break;
                case 6:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICECOMMISSIONS);
                    break;
                case 7:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_ONLINEBOOKING);
                    break;
                case 8:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_BOOKINGRESTRICTION);
                    break;
                case 9:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_LICENSESINSURANCE);
                    break;
                case 10:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_IMAGEGALLERY);
                    break;
                case 11:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_NOTES);
                    break;
                case this.customTabId: // custom tabs
                    this.buildCrudSecurityKeysBase(this.customTabSecurityKey);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN, true, true);
                    this.loadNotificationSetting();
                    if (this.itemId) {
                        this.loadRating();
                    }
                    break;
            }
            if (this.mainTabAccessHide) {
                this.dataService.getSectionById(this.baseEndpoint, this.itemId, '', this.asLocationId).then((data: Model.Employee) => {
                    this.initializeHeader(data);
                });
                this.mainTabAccessHide = false;
            }
            super.selectSection(item);
        }

        loadNotificationSetting(): any {
            this.dataService.customMethodData("api/Employee/NotificationSetting", "GET", {}).then(
                (result: any) => {
                    this.notificationSetting = result.data;
                },
                (exception: any) => {
                    this.notificationSetting = null;
                });
        }

 

        loadRating(): any {
            this.dataService.customMethodData('api/SaleLine/EmployeeRating', 'POST', { 'EmployeeUserId': this.itemId, isHidden: null, isDeleted: false }).then(
                (response: any) => {
                    this.rating = response.data.length ? response.data : null;
                },
                (exception: any) => {
                    this.rating = null;
                });
        }

        emailEnabled(): boolean {
            return this.notificationSetting && this.notificationSetting.isEmailEnabledCurrentLevel;
        }

        isRatingStarsTile = (value): number => {
            const { rating, answers } = this.ratingsService.ratingsMapFn(value);

            this.ratingLabels.stars = rating;
            this.ratingLabels.reviews = answers;
            return rating;
        }

        isCountRating(value): string {
            let answers = 0,
                allAnswers = 0;

            if (value) {
                value.forEach((item) => {
                    if (item.rating && item.rating != 0) {
                        answers += item.ratingCount;
                    }
                    allAnswers += item.ratingCount;
                });
            }
            return answers === 0 ? 'No ratings yet' : `( ${answers} / ${allAnswers} )`;
        }

        isEmailEEnabled(comunicationType): boolean {
            if (!this.notificationSetting)
                return false
            var notification = _.find(this.notificationSetting.communicationTypeNotifications, function (n) { return n.communicationType == comunicationType && n.communicationTypeUser == Model.CommunicationTypeUserEnum.Employee; });

            return notification.isEmailEnabledCurrentLevel;

        }

        isSMSEEnabled(comunicationType): boolean {
            if (!this.notificationSetting)
                return false
            var notification = _.find(this.notificationSetting.communicationTypeNotifications, function (n) { return n.communicationType == comunicationType && n.communicationTypeUser == Model.CommunicationTypeUserEnum.Employee; });

            return notification.isSmsEnabledCurrentLevel;

        }
        initializeHeader(model: any): void {
            if (!this.isAdding)
                this.headerContent = model.isLocationEmployee ? model.lastName + ', ' + model.firstName : model.userName;

            this.visualizeTabs(model.isLocationEmployee, this.showSharedTab(model));
            // Get TenantDistribution model and build url
            this.getMeevoUrl();
        }

        showSharedTab(model: Model.Employee): boolean {

            //get count of locations where person is Employee and is active

            let cnt = _.select(model.security.userLocations,
                ul => { return ul.location.isEmployee && ul.location.objectState === Model.ObjectStateEnum.Active });

            return Model.Guard.isSomething(model) &&
                this.identityService.inCentralOfficeMode() && (model.homeLocationId === this.actingLocationId) &&
                (model.isShared || (Model.Guard.isSomething(cnt) && cnt.length === 1));

        }

        isFieldDisabledForEditViaSecurity(keyName: string, isDisabled: boolean): boolean {
            return !this.isAdding
                && (!this.securityChecker.hasSecurity(keyName + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                    || isDisabled);
        }

        hideInSandboxEnvironment(): boolean {
            return this.identityService.current().systemSettings.isSandboxEnvironment && this.isEditing;
        }

        get showDelete(): boolean {
            return this.selectedSection.displayNameContentKey === this.contextMessages.sectionMain && super.showDeleteLogic();
        }

        get showCopy(): boolean {
            return this.selectedSection.displayNameContentKey === this.contextMessages.sectionMain && super.showCopyLogic();
        }

        _confirmActivatingResetsTermination(employee: Model.Employee): angular.IPromise<any> {
            this.busyService.stop();
            return this.modalService.alert(this.contextMessages.activateUser, 0, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            })
                .then((response: boolean) => {

                    if (response) {
                        employee.terminatedDate = null;
                        return super.save();
                    } else
                        employee.objectState = Model.ObjectStateEnum.Inactive;
                })
                .finally(() => {
                    this.busyService.start();
                });
        }

        _confirmInactivatingClearsPromos(employee: Model.Employee): angular.IPromise<any> {

            this.busyService.stop();
            return this.modalService.confirmHandler(this.contextMessages.activateUserWithPromo)
                .then((response: boolean) => {
                    if (response)
                        return super.save();
                    else
                        employee.objectState = Model.ObjectStateEnum.Active;
                })
                .finally(() => {
                    this.busyService.start();
                });
        }

        initializeMeevoMessengerSecurity() {
            const messengerKeys: string[] = [
                this.securityKeys.INTEGRATION_TWOWAYSMS + this.securityParts.KEY_PART_READ,
                this.securityKeys.INTEGRATION_TEXTEL + this.securityParts.KEY_PART_READ
            ];

            this.securityChecker.checkAndCache(messengerKeys).then((result: Model.SecurityItem[]) => {
                const twoWaySecItem = result.find((item) => item.key === messengerKeys[0]);

                if (twoWaySecItem.securityAccess !== SecurityAccessEnum.Hide) {
                    this.meevoMessengerSecurityKey = this.securityKeys.INTEGRATION_TWOWAYSMS;
                } else {
                    this.meevoMessengerSecurityKey = this.securityKeys.INTEGRATION_TEXTEL;
                }
            });
        }

        navigateToTextel({ id, firstName, lastName, isRestricted, meevoFile, countryCode, phoneNumber}): void {
            if (!phoneNumber) {
                this.modalService.error('MESSAGE_MEEVO_MESSENGER_ERROR_NO_EMPLOYEE_PHONE_NUMBER');
                return;
            }

            this.goToState(this.appSettings.ROUTE_NAMES.meevoMessenger, {
                id, firstName, lastName, phoneNumber, countryCode, isRestricted, isClient: false, meevoFile
            });
        }

        save(): angular.IPromise<any> {

            if (this.canLocationAddUser < 0 && this.selectedSection.sectionId == 1) {
                this.modalService.error("MESSAGE_USER_LIMIT_EXCEEDED_FREEUP");
                return;
            }

            if (typeof this.selectedSection.auditNounForSave === 'number') {
                (this.selectedSection.model as any).auditNoun = this.selectedSection.auditNounForSave;
            }

            if (this.selectedSection.sectionId !== 0)
                return super.save();
       
            var employee = this.castModel<Model.Employee>();
            if (Model.Guard.isNothing(employee))
                return super.save();

            if (!employee.isLocationEmployee) {
                employee.employeeCode = employee.userName;
            }

            if (Model.Guard.isSomething(employee.terminatedDate) &&
                employee.objectState === Model.ObjectStateEnum.Active &&
                this.selectedSection.originalEntity.objectState === Model.ObjectStateEnum.Inactive) {

                return this._confirmActivatingResetsTermination(employee);
            }

            if (employee.objectState === Model.ObjectStateEnum.Inactive &&
                this.selectedSection.originalEntity.objectState === Model.ObjectStateEnum.Active &&
                employee.isLocationEmployee && Model.Guard.isSomething(employee.promotionId)) {
                return this._confirmInactivatingClearsPromos(employee);

            }

            if (this.isSamePhoneNumber(employee)) {
                this.modalService.alert("MESSAGE_EMPLOYEE_DUPLICATE_PHONENUMBER", 0, true);
                return;
            }

            //Adding silently client to an employee profile on Addding
            if (Model.Guard.isNothing(employee.employeeClientLinkDetail) && (this.isAdding || this.isCopying) && employee.isLocationEmployee && !this.isApplicationModeCO()) {
                this.modalService.confirmHandler(this.contextMessages.clientLinkConfirmation)
                    .then((response: boolean) => {
                        if (response) {
                            employee.isClientLinkNeeded = true;

                        } else {
                            employee.isClientLinkNeeded = false;
                            employee.employeeClientLinkDetail = null;
                        }
                        return super.save();
                    });
            } else {
                var that;
                that = this.sections[0];
                if (Model.Guard.isSomething(that.backup)) {
                    let previousServicePriceLevel = that.backup.defaultServicePriceLevel;
                    if (previousServicePriceLevel !== employee.defaultServicePriceLevel) {
                        this.modalService.alert("MESSAGE_MODAL_EMPLOYEE_PRICE_LEVELS_CHANGED", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                            .then((response: boolean) => {
                                if (response) {
                                    employee.changeAllServicePriceLevel = true;
                                    return super.save();
                                }
                            }).then(() => {
                                employee.changeAllServicePriceLevel = false;
                            }).finally(() => super.save());
                    }
                    else {
                        return super.save();
                    }
                }
                else {
                    if ((this.isApplicationModeCO() === true) || (employee.isLocationEmployee === false) || this.isAdding) {
                        return super.save();
                    }
                }
            }
        }


        visualizeTabs(isLocationEmployee: boolean, showSharedTab: boolean): void {
            let employee = <Model.Employee>this.selectedSection.model;
            this.sections.forEach(s => {
                if (s.noun === null && !employee.security.userLocations[0].location.isEmployee)
                    s.isVisible = false;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_SERVICES')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_LICENSE_INSURANCE')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_COMPENSATION')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_DEDUCTION')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_BOOKING_RESTRICTIONS')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_SERVICE_COMMISSIONS_OVERRIDE')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_IMAGE_GALLERY')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_CLIENT_NOTES')
                    s.isVisible = isLocationEmployee;
                if (s.displayNameContentKey === 'SECTION_EMPLOYEE_SHARED')
                    s.isVisible = showSharedTab;

            });

        }


        /**
        * Deletes the selected item.
        */
        delete(): void {
            this.deleteInternal();
        }

        /**
        * Executes a patch request to update object state.
        */


        get currentEmployee(): Model.Employee {
            return Model.Guard.returnSomething(this.castModel<Model.Employee>());
        }

        customStatePatchInternal(objectState: Model.ObjectStateEnum,
            enableFormStateReset: boolean,
            localParams: any,
            httpMethod: string,
            customEndPoint: string): IPromise<any> {
            if (Model.Guard.isNothing(localParams))
                return;

            this.loadingInProgress = true;

            localParams.entityVersion = this.currentEmployee.entityVersion;
            localParams.objectState = objectState;
            let uri = '';
            if (Model.Guard.isNothing(httpMethod))
                httpMethod = 'PATCH';
            if (this.asLocationId !== null)
                localParams.asLocationId = this.asLocationId;
            // TODO: Find out why we need to pass delete options in query string
            if (Model.Guard.isSomething(customEndPoint))
                uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.itemId}/${customEndPoint}`;
            else
                uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.itemId}`;

            return this.dataService.customMethodData(uri, httpMethod, localParams)
                .then((res) => {
                    this.selectedSection.model = res.data;
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    if (enableFormStateReset)
                        this.mode = Model.MaintenanceFormState.Readonly;
                });
        }

        terminate(terminatedDate: Date,
            doDeleteFutureWorkTimes: boolean,
            doDeleteFutureBlockTime: boolean,
            selectedHomeLocation: Model.LocationListItem,
            doInactivateUserAtAllLocations: boolean): void {
            if (!(this.verifySelectedSectionModel() && (this.selectedSection.model as Model.Employee).isLocationEmployee))
                return;

            const confirmMessage = this.hasPromotion
                ? this.contextMessages.terminateWithPromo
                : this.contextMessages.terminateConfirmation;
            this.modalService.warning(confirmMessage, 0, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            })
                .then((response: boolean) => {

                    let newHomeLocationId = 0;
                    if (Model.Guard.isSomething(selectedHomeLocation))
                        newHomeLocationId = selectedHomeLocation.id;

                    var localParams: any = {
                        deleteWorkTime: doDeleteFutureWorkTimes,
                        deleteBlockTime: doDeleteFutureBlockTime,
                        terminatedDate: terminatedDate,
                        newHomeLocationId: newHomeLocationId,
                        isTerminated: true,
                        inactivateUserAtAllLocations: doInactivateUserAtAllLocations
                    };

                    this.customStatePatchInternal(Model.ObjectStateEnum
                        .Inactive,
                        true,
                        localParams,
                        'PUT',
                        'terminate').then((data) => {
                            if (this.identityService.current().isSingleLocation || (this.identityService.inCentralOfficeMode() && doInactivateUserAtAllLocations)) {
                                this.updateEmployeeMeevoStore(this.selectedSection.model, EmployeeRequestType.Delete, doInactivateUserAtAllLocations);
                            } else {
                                this.updateEmployeeMeevoStore(this.selectedSection.model, EmployeeRequestType.Disassociate);
                            }
                            this.deleteClientProfile(this.selectedSection.model);
                        });

                });

            return;
        }

        isSamePhoneNumber(employeeModel: Model.Employee): boolean {
            if (Model.Guard.isNothing(employeeModel.phoneNumber) || Model.Guard.isNothing(employeeModel.homePhoneNumber))
                return false;
            if (employeeModel.phoneNumber == employeeModel.homePhoneNumber &&
                employeeModel.homeCountryCode == employeeModel.countryCode) {
                return true;
            }
            return false;
        }

        isFieldDisabledForEdit(): boolean {
            const employee = this.castModel<Model.Employee>();
            if (Model.Guard.isNothing(employee))
                return (this.mode === Meevo.Model.MaintenanceFormState.Readonly);
            return (this.mode === Meevo.Model.MaintenanceFormState.Readonly) || (employee.isShared && !this.inHomeLocation());
        }

        inHomeLocation(): boolean {
            const employee = this.castModel<Model.Employee>();
            return (employee.homeLocationId === this.actingLocationId);
        }

        get hasPromotion(): boolean {
            var emp = this.castModel<Model.Employee>();
            return emp.isLocationEmployee && Model.Guard.isSomething(emp.promotionId);
        }

        deleteInternal(): void {
            if (!this.canDelete)
                return;

            let deletePromise: ng.IPromise<any>;

            if (this.verifySelectedSectionModel() && !(this.selectedSection.model as Model.Employee).isLocationEmployee) {
                deletePromise = this.modalService.warning('MESSAGE_DELETE_USER_CONFIRMATION', 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response: boolean) => {
                        this.loadingInProgress = true;
                        // Delete user
                        this.customStatePatchInternal(Model.ObjectStateEnum.Deleted, false, {}, null, null);
                    });
            } else {
                // Validate future appointments for employee
                const uri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.employee}/${this.selectedSection.model.id}/Validate/Appointments`;
                deletePromise = this.dataService.customMethodData(uri, 'GET', null)
                    .then((res) => {
                        if (!res.data) {
                            // Display and capture desicion to delete employee
                            const confirmMessage = this.hasPromotion
                                ? this.contextMessages.deleteWithPromoConfirm
                                : this.contextMessages.deleteConfirm;
                            this.modalService.warning(confirmMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                                .then((response: boolean) => {
                                    this.loadingInProgress = true;

                                    // Display and capture desicion to delete future scheduled work time
                                    var deleteWorkTime = false;
                                    this.modalService.confirmHandler(this.contextMessages.deleteFutureWorkTimeConfirm)
                                        .then((response: boolean) => {
                                            deleteWorkTime = response;

                                            // Display and capture desicion to delete future scheduled block time
                                            var deleteBlockTime = false;
                                            this.modalService.confirmHandler(this.contextMessages.deleteFutureBlockTimeConfirm)
                                                .then((response: boolean) => {
                                                    deleteBlockTime = response;

                                                    var localParams: any = {
                                                        deleteWorkTime: deleteWorkTime,
                                                        deleteBlockTime: deleteBlockTime,
                                                        isTerminated: false
                                                    };

                                                    this
                                                        .customStatePatchInternal(Model.ObjectStateEnum.Deleted,
                                                            false,
                                                            localParams,
                                                            null,
                                                            null).then((data) => {
                                                                if (this.identityService.inCentralOfficeMode() || this.identityService.current().isSingleLocation) {
                                                                    this.updateEmployeeMeevoStore(this.selectedSection.model, EmployeeRequestType.Delete);
                                                                } else {
                                                                    this.updateEmployeeMeevoStore(this.selectedSection.model, EmployeeRequestType.Disassociate);
                                                                }
                                                                this.deleteClientProfile(this.selectedSection.model);
                                                            });
                                                });
                                        });
                                });
                        } else {
                            const FUTURE_APPOINTMENTS_FOUND_MESSAGE =
                                'Employee has future scheduled appointments and cannot be deleted.';
                            this.modalService.alert(FUTURE_APPOINTMENTS_FOUND_MESSAGE);
                        }
                    });
            };

            if (!angular.isUndefined(deletePromise)) {
                // Added for Activity log
                deletePromise.finally(() => {
                    this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
                });
            }
        }

        undelete(): void {
            super.undelete(false, false);
        }

        /*undelete(): void {
            const entityVersion = this.selectedSection.model.entityVersion;
            const objectState = Model.ObjectStateEnum.Inactive;
            // TODO: Find out why we need to pass delete options in query string
            const uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.itemId}`;

            const localParams: any = {
                entityVersion: entityVersion,
                objectState: objectState
            };
            if (this.asLocationId !== null)
                localParams.asLocationId = this.asLocationId;
            // UIndelete employee
            this.dataService.customMethodData(uri, 'PATCH', localParams)
                .then((res) => {
                    this.selectedSection.model = res.data;
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    this.usageTrackingLog(Meevo.Model.VerbEnum.UndeleteButtonClicked, null);
                });
        }*/


        getCentralOfficeCriteria(locId: number): any {
            let criteria: any = {};
            if (this.identityService.current().centralOfficeId === locId) {
                criteria.coFilterByLocationId = locId;
                criteria.coSearchType = Model.CoSearchType.CentralOffice;
                criteria.coBusinessTypeId = this.typeAheadBusinessTypeDetailId;
                criteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOwned;
                criteria.isForCoOnly = true;
                criteria.requireFullAccessUser = (this.identityService.current().fullAccess) ? null : 0;
                criteria.FilterForAssignableRole = (this.identityService.current().fullAccess) ? null : 1;
                criteria.LocationGroupId = locId;
            } else {
                //get the defaults
                // criteria = null;
                criteria.requireFullAccessUser = (this.identityService.current().fullAccess) ? null : 0;
                criteria.FilterForAssignableRole = (this.identityService.current().fullAccess) ? null : 1;
            }

            return criteria;
        }

        getCentralOfficeCriteriaLocationGroup(lgId: any): any {
            let criteria: any = {};

            criteria.coFilterByLocationId = this.identityService.current().centralOfficeId;
            criteria.coSearchType = Model.CoSearchType.CentralOffice;
            criteria.coBusinessTypeId = this.typeAheadBusinessTypeDetailId;
            criteria.coSearchResultFilter = Model.CoSearchResultsFilter.All;
            criteria.isForCoOnly = false;
            criteria.requireFullAccessUser = (this.identityService.current().fullAccess) ? null : 0;
            criteria.FilterForAssignableRole = (this.identityService.current().fullAccess) ? null : 1;
            criteria.LocationGroupId = lgId;

            return criteria;
        }

        getSmartCenterCoCriteria(locId: number): any {

            let criteria: any = {};
            if (this.identityService.current().centralOfficeId === locId) {
                criteria.coFilterByLocationId = locId;
                criteria.coSearchType = Model.CoSearchType.CentralOffice;
                criteria.coBusinessTypeId = this.typeAheadBusinessTypeDetailId;
                criteria.coSearchResultFilter = Model.CoSearchResultsFilter.LocationOwned;
                criteria.isAvailableCo = true;

            } else {
                //get the defaults
                //criteria = null;
                criteria.coSearchType = null;
                criteria.IncludeSystemSmartCenters = true;
            }
            return criteria;
        }


        openTerminateEditor(context: EmployeeContext, employee: Model.Employee) {
            // Initialize modal with employee resources
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/employee/sectionViews/terminateTemplate.html',
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    employee: employee
                },
                controller: 'meevo.plugins.employee.TerminateController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        }

        openApplyTemplateEditor(context: any) {
            // Initialize modal with employee resources
            const options: Components.Modal.IModalOptions = {
                templateUrl: `app/plugins/${this.pluginFolder}/sectionViews/applyTemplate.html`,
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    isClear: false
                },
                controller: 'meevo.plugins.employee.ApplyTemplateController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        }

        applyTemplate(appliedTemplate: Model.AppliedTemplate) {
            this.modalService.warning(this.contextMessages.applyTemplateConfirm, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((response: boolean) => {
                    var applyMainSection = false;
                    if (appliedTemplate.sections
                        .filter(section => section.sectionType === Model.AppliedTemplateSectionTypeEnum.Main).length <=
                        0) {
                        const emp = this.castModel<Model.Employee>();
                        if (Model.Guard.isNothing(_
                            .find(emp.appliedTemplates, at => at.templateId === appliedTemplate.templateId))) {
                            emp.appliedTemplates.push(appliedTemplate);
                        }

                    } else {
                        this.loadingInProgress = true;
                        var uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/TemplateApply`;
                        // prepare request payload
                        const params = {
                            model: this.selectedSection.model,
                            templateId: appliedTemplate.templateId
                        };
                        return this.dataService.customMethodData(uri, 'PUT', params)
                            .then((res) => {
                                // update client side model
                                this.selectedSection.model = res.data;
                                // add to applied template collection
                                const emp = this.castModel<Model.Employee>();
                                if (Model.Guard.isNothing(_
                                    .find(emp.appliedTemplates, at => at.templateId === appliedTemplate.templateId))) {
                                    emp.appliedTemplates.push(appliedTemplate);
                                }
                            })
                            .finally(() => {
                                this.loadingInProgress = false;
                            });
                    }
                });
        }

        openChangeHomeLocationModal = (context: any) => {
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/employee/sectionViews/changeHomeLocationModal.html',
                locals: {
                    context: context
                },
                controller: 'meevo.plugins.employee.ChangeHomeLocationModalController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        };

        openChangePassword(user: Model.User) {

            if (Model.Guard.isNothing(user))
                return;

            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/components/changePassword/changePassword.html',
                clickOutsideToClose: false,
                locals: {
                    model: user,
                    userId: user.id,
                    userName: user.userName,
                    requireChangePassword: false
                },
                controller: 'meevo.changePassword.ChangePasswordController',
                controllerAs: 'changePassword',
                bindToController: true
            };
            this.modalService.showCustom(options)
                .then((result) => {
                    console.log(result);
                });
        }

        unlockUser(user: Model.User) {
            if (Model.Guard.isNothing(user))
                return;

            this.busyService.start();
            const uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}User/Unlock/${this.selectedSection.model
                .id}`;
            this.dataService.customMethodData(uri, 'PATCH', null)
                .then(response => {
                    // Locally update property...probably unnecessary for now
                    user.hasExceededRetryAttempts = false;
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        openPromotionEditor(promotionId: string, employeeId: string) {
            // Initialize modal with employee resources
            if (this.mode === Model.MaintenanceFormState.Adding) {
                this.modalService.alert(this.contextMessages.cannotTemplateNew,
                    Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            const endpoint = this.appSettings.ROUTE_NAMES.employeeTemplatePromotions;

            if (Model.Guard.isSomething(promotionId)) {
                // Build params for editing promo
                const stateParams = {
                    targetState: Model.MaintenanceFormVisualState.Detail,
                    actionState: Model.MaintenanceFormState.Editing,
                    id: promotionId
                };
                this.goToState(endpoint, stateParams);
            } else {
                // Build params for new promo
                const stateParams = {
                    targetState: Model.MaintenanceFormVisualState.Detail,
                    actionState: Model.MaintenanceFormState.Adding,
                    employeeId: employeeId
                };
                this.goToState(endpoint, stateParams);
            }
        }


        goToState(stateName, stateParams) {
            this.rootScope.$broadcast('gotoState',
                {
                    stateName: stateName,
                    stateParams: stateParams
                });
        }

        currentLoggedInUserId = { UserID: this.identityService.loggedInUserId(), ExcludeIdList: this.identityService.userBusinessTypes.length <= 0 ? this.identityService.current().centralOfficeId : null };

        //get currentLoggedInUserId(): Guid {
        //    return {UserID:this.identityService.loggedInUserId()}
        //}

        postAdd(model: any): void {
            if (this.selectedSection.sectionId === 0 && Model.Guard.isSomething(this.castModel<Model.Employee>())) {
                model.isStorageUpdated = false;
                super.postAdd(model);
                this.initializeHeader(model);
                this.updateEmployeeMeevoStore(model, EmployeeRequestType.Add);
                this.updateClientProfile(model);
                this.fireEmployeeChangeEvent();
                if (this.identityService.inCentralOfficeMode()) {
                    this.asLocationId = this.actingLocationId;
                }
            }
            this.selectedSection.postAdd();
        }

        postUpdate(model: any): void {
            if (this.selectedSection.sectionId === 0 && Model.Guard.isSomething(this.castModel<Model.Employee>())) {
                model.isStorageUpdated = false;
                super.postUpdate(model);
                this.headerContent = model.isLocationEmployee ? model.lastName + ', ' + model.firstName : model.userName;
                this.updateEmployeeMeevoStore(model, EmployeeRequestType.Update);
                this.updateClientProfile(model);
                this.fireEmployeeChangeEvent();
            }
            if (this.selectedSection.sectionId === 1 && Model.Guard.isSomething(this.castModel<Model.UserSecurity>()) && this.identityService.inCentralOfficeMode()) {
                this.updateEmployeeLocationAccessMeevoStore(model);
            }
            this.selectedSection.postUpdate();
        }

        postCancel(): void {
            let model = this.castModel<Model.Employee>();
            if (model) {
                this.visualizeTabs(model.isLocationEmployee, this.showSharedTab(model));
            }
            super.postCancel();
            this.selectedSection.postCancel();
        }

        postCopy(): void {
            super.postCopy();
            const model = this.castModel<Model.Employee>();
            model.displayName = undefined;
            model.userName = undefined;
            model.password = undefined;
            model.passwordLastChangedDateTime = undefined;
            model.externalId = undefined;
            model.emailAddress = undefined;
            model.employeeCode = undefined;
            model.prefix = undefined;
            model.firstName = undefined;
            model.middleName = undefined;
            model.lastName = undefined;
            model.gender = Model.GenderEnum.NotSpecified;
            model.hireDate = moment().format();
            model.address.address1 = undefined;
            model.address.address2 = undefined;
            model.address.city = undefined;
            model.address.state = undefined;
            model.address.zipCode = '';
            model.address.country = undefined;
            model.phoneNumber = undefined;
            model.homePhoneNumber = undefined;
            model.birthDate = undefined;
            model.nickName = undefined;
            model.promotionId = undefined;
            model.promotionDate = undefined;

            //TODO:follow-up on how to intialize content type from source.
            model.fileGuid = undefined;
            model.meevoFile = undefined;
            model.isStorageUpdated = undefined;
            model.isShared = false;
            model.sharedLocations = undefined;
            model.employeeClientLinkDetail = undefined;
            model.isClientLinkNeeded = false;
        }

        fileTypesEnum = Model.FileTypes;

        fireEmployeeChangeEvent(): void {
            this.rootScope.$broadcast('employeeChanged');
        }

        getServicesDefaultCriteria() {
            this.CanPerformFlagSetToShowAll = false;
            // Default to showing Yes (Can Perform) for services filter
            return { 'doesNotPerform': '0' };
        }

        deleteClientProfile(model: Model.Employee): void {
            if (this.selectedSection.sectionId !== 0
                || !model
                || !model.isLocationEmployee
            ) {
                return;
            }

            let entity: any = {
                employeeId: model.id,
            };
            let params: any = {
                asLocationId: this.asLocationId,
            };

            this.dataService.customMethodData(this.appSettings.API_ROOT + "/Membership/Client/EmployeeMembership", "PATCH", entity, params);
        }

        updateClientProfile(model: Model.Employee): void {
            if (this.selectedSection.sectionId !== 0
                || !model
                || !model.isLocationEmployee
                || (this.selectedSection.originalEntity && _.isEqual(model.employeeClientLinkDetail, this.selectedSection.originalEntity.employeeClientLinkDetail))
            ) {
                return;
            }

            let entity: any = {
                employeeId: model.id,
            };
            let params: any = {
                asLocationId: this.asLocationId,
            };

            this.dataService.customMethodData(this.appSettings.API_ROOT + "/Membership/Client/EmployeeMembership", "POST", entity, params);
        }

        updateEmployeeMeevoStore<T>(model: Model.Employee, updateType: EmployeeRequestType = 1, enforceAction: boolean = false): void {
            if (!this.verifySelectedSectionModel()) {
                return;
            }

            // Validation for Update
            let original: Model.Employee = this.selectedSection.originalEntity;
            if (updateType === EmployeeRequestType.Update) {
                if (!(model.userName !== original.userName
                    || model.isLocationEmployee !== original.isLocationEmployee
                    || model.firstName !== original.firstName
                    || model.lastName !== original.lastName
                    || model.emailAddress !== original.emailAddress
                    || !_.isEqual(model.learningTracks, original.learningTracks)
                    || model.homePhoneNumber !== original.homePhoneNumber
                    || model.phoneNumber !== original.phoneNumber
                    || model.objectState !== original.objectState
                    || model.fullAccess !== original.fullAccess
                    || model.accessLevel != original.accessLevel

                )) {
                    return;
                }

                if (model.objectState !== original.objectState && model.objectState === Model.ObjectStateEnum.Inactive) {
                    updateType = EmployeeRequestType.Disassociate;
                }
            }

            let entity: any = {
                employeeId: model.id,
                type: updateType,
                enforceAction: enforceAction
            };
            let params: any = {
                asLocationId: this.asLocationId
            };

            this.dataService.customMethodData(this.appSettings.API_ROOT + "/MeevoStore/Employee", "PUT", entity, params).then((response: any) => {
                if (response && response.data && response.data.entityVersion) {
                    this.selectedSection.model.entityVersion = this.selectedSection.model.entityVersion > response.data.entityVersion ? this.selectedSection.model.entityVersion : response.data.entityVersion;  
                    if (response.data.salesForceId) {
                        this.selectedSection.model['salesForceId'] = response.data.salesForceId;
                    }
                }
            });
        }

        updateEmployeeLocationAccessMeevoStore(model: Model.UserSecurity): void {
            if (!this.verifySelectedSectionModel()) {
                return;
            }

            // Validation for Update
            let originalUserLocations: Model.UserSecurity = this.selectedSection.originalEntity;
            var originallocations = originalUserLocations.userLocations;
            var modelLocations = model.userLocations;


            var pluckOldLocations = _.pluck(originallocations, 'location');
            var pluckNewLocations = _.pluck(modelLocations, 'location');
            var filter = _.filter(pluckNewLocations, function (obj) { return !_.findWhere(pluckOldLocations, obj); });
            var addedLocations = _.where(filter, { objectState: Model.ObjectStateEnum.Active });
            var removedLocations = _.where(filter, { objectState: Model.ObjectStateEnum.Inactive });

            if (Model.Guard.isSomething(addedLocations) && Model.Guard.isSomething(removedLocations) && (addedLocations.length > 0 || removedLocations.length > 0)) {

                let entity: any = {
                    employeeId: model.userId,
                    addeddLocations: addedLocations,
                    removedLocations: removedLocations
                };


                this.dataService.customMethodData(this.appSettings.API_ROOT + "/MeevoStore/Employee/Locations", "POST", entity).then((response: any) => {

                });
            }
        }

        isEmailEnabledAtHigherLevel(communicationType: any): boolean {
            var isEnabled = true;
            if (this.notificationSetting) {
                var notification = this.notificationSetting.communicationTypeNotifications.filter(n => n.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Employee && n.communicationType === communicationType)[0];
                if (notification) {
                    isEnabled = notification.isEmailEnabled && notification.isEmailEnabledCurrentLevel;
                }
            }
            return isEnabled;
        }

        isSMSEnabledAtHigherLevel(communicationType: any): boolean {
            var isEnabled = true;
            if (this.notificationSetting) {
                var notification = this.notificationSetting.communicationTypeNotifications.filter(n => n.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Employee && n.communicationType === communicationType)[0];
                if (notification) {
                    isEnabled = notification.isSMSEnabled && notification.isSmsEnabledCurrentLevel;
                }
            }
            return isEnabled;
        }


        showRevertIndicator(empNotification: any, communicationMethod: Meevo.Model.CommunicationMethodEnum): boolean {
            var canShow = false;
            if (empNotification) {
                if (communicationMethod === Meevo.Model.CommunicationMethodEnum.Email) {
                    if (empNotification.isEmailEnabled !== empNotification.isEmailEnabledDefault)
                        canShow = true;
                }
                else if (communicationMethod === Meevo.Model.CommunicationMethodEnum.SMS) {
                    if (empNotification.isSMSEnabled !== empNotification.isSMSEnabledDefault)
                        canShow = true;
                }
            }
            return canShow;
        }

        // Pager
        // Virtual method to interact with paging functionality

        public forcePageLoading(criteria: any, itemsPerPage?: number): void {
        }

        getServicesShwoAllCriteria() {
            // show all (Can Perform) for services filter
            return { 'doesNotPerform': '' };
        }

        canPerformChanged(): void {
            this.serviceCanPerformFlag = true;
        }

        public pagerOnPageLoaded() {

            if (this.selectedSection.sectionId == 2 && Model.Guard.isSomething(this.selectedSection.model) && Model.Guard.isSomething(this.selectedSection.model["items"])) {

                var result = this.selectedSection.model["items"].count;
                if (result == 0 && this.pagerEmpServiceFilterCanPerforme == '0' && !this.serviceCanPerformFlag) {
                    let criteria = this.getServicesShwoAllCriteria();
                    if (this.CanPerformFlagSetToShowAll == true) {
                        return null;
                    }
                    this.timeout(() => this.forcePageLoading(criteria), 50);
                    this.CanPerformFlagSetToShowAll = true;

                }
            }
        }
        public setPagerFilterParms(canPerform: any) {
            this.pagerEmpServiceFilterCanPerforme = canPerform;
        }

        revertToParent(empNotification: any, communicationMethod: Meevo.Model.CommunicationMethodEnum): void {
            if (empNotification) {
                if (communicationMethod === Meevo.Model.CommunicationMethodEnum.Email) {
                    if (empNotification.isEmailEnabled !== empNotification.isEmailEnabledDefault)
                        empNotification.isEmailEnabled = empNotification.isEmailEnabledDefault;
                }
                else if (communicationMethod === Meevo.Model.CommunicationMethodEnum.SMS) {
                    if (empNotification.isSMSEnabled !== empNotification.isSMSEnabledDefault)
                        empNotification.isSMSEnabled = empNotification.isSMSEnabledDefault;
                }
            }
        }
       
        getMeevoUrl() {
            this.dataService.customMethodData("api/tenant/businessinfo/customerportalurl", "GET", null)
            .then((result: any) => {
                if (result && result.data && result.data.onlineBookingUrl) {
                    this.obAppEmpUrl = result.data.onlineBookingUrl;
                }
                this.obAppEmpUrl += `&empId=${this.selectedSection.model.id}&empEntityId=${Model.EmployeeEntityTypeEnum.Employee}`;
            });
    }

        private _obAppEmpUrl: string = '';

        get obAppEmpUrl(): string {
            return this._obAppEmpUrl;
        }

        set obAppEmpUrl(value: string) {
            this._obAppEmpUrl = value;
        }

    }
}
